import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DesignHelper } from 'src/app/features/floor-plan/helpers/DesignHelper';
import { TableProblemsDialogComponent } from '../form/table-problems-dialog/table-problems-dialog.component';
import { Floor, FloorItem, FloorViewerType, ReservationFormResponse, TabelStatusEnum } from '../../models/Reservation';

@Component({
  selector: 'app-all-floors-viewer',
  templateUrl: './all-floors-viewer.component.html'
})
export class AllFloorsViewerComponent extends DesignHelper implements OnInit {
  @Input() floors: any[] = [];
  @Input() tablesToSelect!: number[];
  @Input() reservationResponse: ReservationFormResponse | null = null;

  @Input() isView = false;
  @Input() disabled = false;
  @Input() required = false;

  @Output() selectedFloor = new EventEmitter<Floor>();
  @Output() selectedTables = new EventEmitter<FloorItem[]>();

  @Input() restaurantId: any;
  @Input() reservationDate: any;
  openServarsList!: boolean;

  dataLoading = false;
  @Input() floorId!: number;
  floor!: Floor;
  tables: FloorItem[] = [];
  hasProblem = false;

  override scale = 0.7;
  minScale = 0.5;
  maxScale = 1.5;
  screesDim = {
    screenWidth: 1400,
    screenHeight: 820
  }
  currentView: FloorViewerType = FloorViewerType.ContentView;

  constructor(
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
  ) { super(); }

  ngOnInit(): void {
    if (this.floors.length && !this.floorId) {
      this.floor = this.floors[0];
      this.floorId = this.floors[0].id;
      this.selectedFloor.emit(this.floor);
    }
    if (this.floorId) {
      this.floorChanged();
    }
    if (this.tablesToSelect?.length) {
      this.selectTables();
    }
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['floors']?.currentValue) {
      this.floors = changes['floors']?.currentValue;
      this.floorChanged();
    }
    if (changes['tablesToSelect']?.currentValue) {
      this.floors.forEach(element => {
        element.tabels.map((item: FloorItem) => { item.selected = changes['tablesToSelect']?.currentValue.includes(item.id) });
      });
    }
    this.hasProblem = false;
    if (changes['reservationResponse']?.currentValue) {
      const reservationResponse = changes['reservationResponse'].currentValue as ReservationFormResponse;
      if (!reservationResponse?.result?.success) {
        this.hasProblem = true;
      }
      this.floor?.tabels.map((item: FloorItem) => {
        item.recommended = reservationResponse.tabelsRecommendation?.some((x: any) => x == item.id)
      });
    }
    this.cdr.detectChanges();
  }
  selectTables() {
    this.tablesToSelect.forEach(tableId => {
      const table = this.floor.tabels.find(item => item.id == tableId);
      if (table) {
        this.tableSelected(table);
      }
    });
  }

  floorChanged() {
    this.floor = this.floors.find(item => item.id == this.floorId);
    this.selectedFloor.emit(this.floor);
    this.floors.forEach(element => {
      element.tabels.map((item: FloorItem) => { item.selected = false });
    });
    this.tables = [];
    this.selectedTables.emit(this.tables);
  }

  tableSelected(table: FloorItem) {
    if (this.disabled) return;
    // if (this.isView) {
    //   if (
    //     table.currentReservations?.reservationStatus == ReservationStatusEnum.Seated
    //     || table.currentReservations?.reservationStatus == ReservationStatusEnum.Arrived
    //     &&
    //     !(
    //         table.tableStatus == TabelStatusEnum.Blocked
    //         || table.tableStatus == TabelStatusEnum.Free
    //         || table.tableStatus == TabelStatusEnum.Reserved
    //       )
    //     ) { return };
    // } else {
    //   if (table.tableStatus == TabelStatusEnum.Blocked) return;
    // }
    // if (table.tableStatus !== TabelStatusEnum.Free && this.isView) return;
    if (table.tableStatus == TabelStatusEnum.Blocked && !this.isView) return;

    if (table.category == 1) {
      table.selected = !table.selected
    }
    this.tables = this.floor.tabels.filter(item => item.selected);
    this.selectedTables.emit(this.tables);
  }

  setZoom(zoomType: string) {
    this.scale = Number(this.scale.toFixed(1));
    if (zoomType == 'in' && this.scale < this.maxScale) {
      this.scale += 0.1;
    }
    if (zoomType == 'out' && this.scale > this.minScale) {
      this.scale -= 0.1;
    }
    if (zoomType == 'fit') {
      this.scale = 1;
    }
    document.getElementsByClassName('design-area-wrapper')[0].scroll(0, 0);
  }

  openProblemsDialog() {
    this.dialog.open(TableProblemsDialogComponent, {
      width: '50rem',
      data: {
        reservationData: null,
        reservationResponse: this.reservationResponse,
        errorType: 0
      }
    });
  }
}
